// extracted by mini-css-extract-plugin
export default {"overlay":"popUp_overlay__sjt+n","popup":"popUp_popup__3Jn+O","close":"popUp_close__Nut2u","content":"popUp_content__chdf5"};